var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.name},[_vm._v("\n  "+_vm._s(_vm.$t('module_adgroup_custome_link'))+"\n  "),_c('question-tooltip',{class:(_vm.name + "__tip")},[_c('div',[_vm._v(_vm._s(_vm.$t('module_ad_custom_deeplink_hint')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }